import React, { useState, useEffect } from 'react';
import {
  Form,
  Card,
  Select,
  Row,
  Col,
  Input,
  InputNumber,
  Spin,
  message,
  Image,
  DatePicker,
  Space,
  Tag
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllContainers,
  createSampling,
  getPastSamplingDetails,
  getsamples,
  getAllSample
  // updateSampling
} from '../../redux/slice';
import {
  getAllDispenseBooths,
  getBalance
} from '@/features/dispensing/redux/slice';
import CustomTable from 'common/Content/CustomTable';
import moment from 'moment';
import CustomButton from '@/common/CustomButton';
import {
  QrcodeOutlined,
  EditOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import { QrScanSingleShotModal } from '@/common/QrScan';
import { history } from 'app/history';
import { useLocation } from 'react-router-dom';
import { getLoggedInUser } from 'utilities/helpers';
import truck from '@/features/qa/components/images/truck-delivery-done.gif';
import VerificationModal from '@/features/material/components/VerificationModal';

const { TextArea } = Input;
const SamplingMaterialsPage = () => {
  const dateFormat = 'DD-MMM-YYYY';

  const [form] = Form.useForm();
  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);
  const { allMaterials } = useSelector((state) => state.stocks);
  const { user } = getLoggedInUser();

  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [containers, setContainers] = useState([]);

  const [openCam, setOpenCam] = useState(false);
  const [containerDetails, setContainerDetails] = useState([]);
  const [pastData, setPastData] = useState([]);
  const [containerChange, setContainerChange] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [truckShow, setTruckShow] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [sampleData, setSampleData] = useState({});
  const [samplingData, setSamplingData] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [dispenseBooths, setDispenseBooths] = useState([]);
  const [portID, setPortID] = useState('');
  const [balancetype, setBalanceType] = useState('');
  const [ipAddress, setIpAddress] = useState();
  const [lCStatus, setLCStatus] = useState(false);
  const [materialType, setMaterialType] = useState('');
  const [sampledContainers, setSampledContainers] = useState([]);
  console.log(setContainerDetails, pastData);
  console.log(containerDetails);
  useEffect(() => {
    handleGetSamplesById();
  }, []);

  useEffect(() => {
    handleGetDispenseBooths();
  }, []);

  const handleGetDispenseBooths = () => {
    dispatch(getAllDispenseBooths()).then((result) => {
      if (result?.payload?.success) {
        let sampling_dispense_booths = result?.payload?.data.filter(
          (data) => data?.bal_type === 'sampling'
        );
        console.log(sampling_dispense_booths, 'sampling_dispense_booths');
        setDispenseBooths(sampling_dispense_booths);
      }
    });
  };

  const handleGetSamplesById = () => {
    const payload = { id: searchParams.get('id') };
    dispatch(getsamples(payload)).then((response) => {
      if (response?.payload?.success) {
        console.log('>>>>>>>>>.', response?.payload?.data);
        setContainerDetails([
          {
            batch_detail: response?.payload?.data?.container?.batch_detail,
            createdAt: response?.payload?.data?.createdAt,
            received_date: response?.payload?.data?.received_date
          }
        ]);
        form.setFieldsValue({
          warehouse_containers: response?.payload?.data?.container?.number,
          quantity: response?.payload?.data?.quantity
            ? parseFloat(
                response?.payload?.data?.uom == `No.'s`
                  ? response?.payload?.data?.quantity
                  : response?.payload?.data?.quantity * 1000
              ).toFixed(3)
            : 'NA',
          retest_date: response?.payload?.data?.retest_date
            ? moment(response?.payload?.data?.retest_date)
            : '',
          ar_number: response?.payload?.data?.batch_detail?.ar_number || 'NA',
          uom: response?.payload?.data?.uom,
          sampling_date: moment(response?.payload?.data?.sampling_date),
          received_date: moment(response?.payload?.data?.received_date),
          material_type: response?.payload?.data?.material_type || '',
          conversion_factor: response?.payload?.data?.conversion_factor
            ? parseFloat(response?.payload?.data?.conversion_factor)
            : '',
          source_uom: response?.payload?.data?.source_uom || '',
          identification_qty: response?.payload?.data?.identification_qty
            ? parseFloat(response?.payload?.data?.identification_qty)
            : '',
          pooled_qty: response?.payload?.data?.pooled_qty
            ? parseFloat(response?.payload?.data?.pooled_qty)
            : '',
          equipment_name: response?.payload?.data?.equipment_name || ''
        });
        if (response?.payload?.data?.material_type) {
          setMaterialType(response?.payload?.data?.material_type);
        }
      }
    });
  };
  /* Fetch containers already sampled (in DB) for this batch, to show as tags
     and warn before the user re-adds one. Skipped in edit mode. */
  const handleGetSampledContainers = (batchNumber) => {
    if (!batchNumber || searchParams.get('id')) return;
    /* Once a batch is locked (rows added), don't refresh tags for a different
       batch — keeps the tag list consistent with the locked batch. */
    if (
      samplingData?.length > 0 &&
      samplingData[0]?.batch_details_id !== batchNumber
    ) {
      return;
    }
    const payload = { all: true, search: batchNumber, page: 1, per_page: 9999 };
    dispatch(getAllSample(payload)).then((response) => {
      if (response?.payload?.success) {
        const data = response?.payload?.data || [];
        setSampledContainers(
          data.map((item) => ({
            number: item?.container?.number,
            ar_number: item?.ar_number
          }))
        );
      } else {
        setSampledContainers([]);
      }
    });
  };

  const onChange = (value) => {
    console.log(value);
    setContainerChange(true);
    const details = containers.filter(
      (containers) => containers.number === value
    );
    if (details?.[0]?.batch_detail?.lc_status == 'QALC Approved') {
      setContainerDetails(details);
      setLCStatus(
        details?.[0]?.batch_detail?.lc_status == 'QALC Approved' ? true : false
      );
      const payload = { container_id: value };
      dispatch(getPastSamplingDetails(payload)).then((response) => {
        if (response?.payload?.success) {
          setPastData(response?.payload?.data);
        }
      });
      handleGetSampledContainers(
        details?.[0]?.batch_detail?.inhouse_batch_number
      );
    } else {
      setLCStatus(false);
      message.error('Please select a LC approved container');
    }
  };
  console.log(allMaterials);
  console.log(containers);

  const onSearch = (value) => {
    setSearch(value);
    let payload = { search: search };
    search.length > 5
      ? dispatch(getAllContainers(payload)).then((response) => {
          if (response?.payload?.success) {
            setContainers(response?.payload?.data);
          }
        })
      : '';
  };
  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      let payload1 = {
        search: scanData.text.slice(scanData.text.lastIndexOf('/') + 1)
      };
      dispatch(getAllContainers(payload1)).then((response) => {
        if (response?.payload?.success) {
          // setContainers(response?.payload?.data);
          const data = response?.payload?.data;
          setContainerDetails(data);
          setContainerChange(true);
          form.setFieldsValue({
            warehouse_containers: scanData.text.slice(
              scanData.text.lastIndexOf('/') + 1
            )
          });
          if (data?.[0]?.batch_detail?.lc_status == 'QALC Approved') {
            setLCStatus(true);
            const payload = {
              container_id: scanData.text.slice(
                scanData.text.lastIndexOf('/') + 1
              )
            };
            dispatch(getPastSamplingDetails(payload)).then((response) => {
              if (response?.payload?.success) {
                setPastData(response?.payload?.data);
              }
            });
            handleGetSampledContainers(
              data?.[0]?.batch_detail?.inhouse_batch_number
            );
          } else {
            setLCStatus(false);
            message.error('Please select a LC approved container');
          }
          setOpenCam(false);
        }
      });
      // const details = containers.filter(
      //   (containers) =>
      //     containers.number ===
      //     scanData.text.slice(scanData.text.lastIndexOf('/') + 1)
      // );
      // console.log(
      //   details,
      //   scanData.text.slice(scanData.text.lastIndexOf('/') + 1),
      //   containers,
      //   'details'
      // );
    }
  };

  const showConversionFields =
    materialType === 'Solvent' || materialType === 'Capsules';

  // Calculate quantity as sum of identification_qty and pooled_qty, applying conversion factor if applicable
  const calculateQuantity = () => {
    const identificationQty =
      parseFloat(form.getFieldValue('identification_qty')) || 0;
    const pooledQty = parseFloat(form.getFieldValue('pooled_qty')) || 0;
    const cf = parseFloat(form.getFieldValue('conversion_factor')) || 1;
    let totalQuantity;
    if (materialType === 'Capsules') {
      totalQuantity = Math.ceil((identificationQty + pooledQty) * (1000 / cf));
    } else if (materialType === 'Solvent') {
      totalQuantity = (identificationQty + pooledQty) * cf;
    } else {
      totalQuantity = (identificationQty + pooledQty) * 1;
    }
    form.setFieldsValue({ quantity: totalQuantity || null });
  };

  const handleMaterialTypeChange = (value) => {
    setMaterialType(value);
    if (value === 'Raw Material' || value === 'Packing') {
      form.setFieldsValue({ conversion_factor: '', source_uom: '' });
    }
    calculateQuantity();
  };

  const handleAddContainer = async () => {
    console.log(form.getFieldValue('warehouse_containers'));

    /*Check : if the container id already exists in samplingData to avoid duplicate*/
    if (
      samplingData?.some(
        (sample) => sample?.container_id === containerDetails[0]?.id
      )
    ) {
      message.error('Container already Added.');
      return;
    }

    /*Check : if the container is not selected */
    if (!containerDetails.length > 0) {
      message.error('Please select a container.');
      return;
    }

    /*Check : if this container is already sampled (persisted in DB) for this
      batch — mirrors the backend (container + AR number) uniqueness guard. */
    if (
      sampledContainers?.some(
        (c) =>
          c?.number === containerDetails[0]?.number &&
          c?.ar_number === containerDetails[0]?.batch_detail?.ar_number
      )
    ) {
      message.error(
        `Container ${containerDetails[0]?.number} is already sampled for this batch.`
      );
      return;
    }

    /* validate the form */
    await form.validateFields();

    /*CHECK : throw Error toaster if the container is selected from different batch */
    if (
      containerDetails[0]?.batch_detail?.inhouse_batch_number &&
      samplingData.length > 0 &&
      samplingData?.some(
        (sample) =>
          sample?.batch_details_id !==
          containerDetails[0]?.batch_detail?.inhouse_batch_number
      )
    ) {
      // error message
      message.error('You cannot add containers from different batches.');
    } else if (
      samplingData.length > 0 &&
      samplingData?.some(
        (sample) =>
          sample?.material_type !== form.getFieldValue('material_type')
      )
    ) {
      message.error('All containers must have the same material type.');
    } else if (
      containerDetails?.length > 0 &&
      !samplingData?.some(
        (sample) => sample?.container_id === containerDetails[0]?.id
      )
    ) {
      console.log('containerDetails>>>>', containerDetails);
      setSamplingData([
        ...samplingData,
        {
          container_id: containerDetails[0]?.id,
          uom: form.getFieldValue('uom'),
          ar_number: containerDetails[0]?.batch_detail?.ar_number,
          identification_qty: form.getFieldValue('identification_qty'),
          pooled_qty: form.getFieldValue('pooled_qty'),
          quantity: form.getFieldValue('quantity'),
          equipment_name: form.getFieldValue('equipment_name'),
          received_date: containerDetails[0]?.createdAt,
          sampling_date: moment().format('YYYY-MM-DD'),
          batch_details_id:
            containerDetails[0]?.batch_detail?.inhouse_batch_number,
          batch_record_id: containerDetails[0]?.batch_detail?.id,
          container_num: form.getFieldValue('warehouse_containers'),
          material_type: form.getFieldValue('material_type') || '',
          conversion_factor: showConversionFields
            ? form.getFieldValue('conversion_factor')
            : '',
          source_uom: showConversionFields
            ? form.getFieldValue('source_uom')
            : '',
          notes: ''
        }
      ]);
      form.resetFields();
    }
  };

  const removeContainer = (index) => {
    console.log('remove', index);
    const newSamplingData = [...samplingData];
    newSamplingData.splice(index, 1);
    setSamplingData(newSamplingData);
  };

  /* Clear all sampling form state after a successful submit. */
  const resetSamplingForm = () => {
    form.resetFields();
    setSamplingData([]);
    setContainerDetails([]);
    setSampledContainers([]);
    setLCStatus(false);
    setMaterialType('');
    setContainerChange(false);
  };

  const onSubmit = () => {
    if (!samplingData?.length) {
      message.error('Please add at least one container to Sampling Details.');
      return;
    }
    setIsSubmit(true);
    const payload = {
      // Batch is taken from the locked rows (samplingData), NOT containerDetails,
      // which can still hold a rejected different-batch container.
      batch_details_id: samplingData[0]?.batch_record_id,
      samplingData
    };
    dispatch(createSampling(payload)).then((response) => {
      if (response?.payload?.success) {
        setTruckShow(false);
        message.success(response?.payload?.message);
        resetSamplingForm();
        history.push('/samples-list');
        setIsSubmit(false);
      } else {
        message.error(response?.payload?.message);
        setTruckShow(false);
        setIsSubmit(false);
      }
    });
  };
  const onFinish = (values) => {
    console.log(values?.quantity, 'values?.quantity');
    setTruckShow(true);
    if (containerChange && !searchParams.get('id')) {
      // const payload = {
      //   container_id: containerDetails[0]?.id,
      //   batch_details_id: containerDetails[0]?.batch_detail?.id,
      //   quantity: values?.quantity,
      //   received_date: containerDetails[0]?.createdAt,
      //   ar_number: values?.ar_number,
      //   sampling_date: moment().format('YYYY-MM-DD'),
      //   retest_date: values?.retest_date,
      //   uom: values?.uom
      // };
      if (!samplingData?.length) {
        message.error('Please add at least one container to Sampling Details.');
        setTruckShow(false);
        return;
      }
      const payload = {
        // Batch from the locked rows, not the last-selected container.
        batch_details_id: samplingData[0]?.batch_record_id,
        samplingData
      };
      dispatch(createSampling(payload)).then((response) => {
        if (response?.payload?.success) {
          setTruckShow(false);
          message.success(response?.payload?.message);
          resetSamplingForm();
          history.push('/samples-list');
        } else {
          setTruckShow(false);
        }
      });
    } else if (searchParams.get('id')) {
      setIsModal(true);
      const payload = {
        container_id: containerDetails[0]?.id,
        batch_details_id: containerDetails[0]?.batch_detail?.id,
        quantity: values?.quantity,
        received_date: containerDetails[0]?.createdAt,
        ar_number: values?.ar_number,
        id: searchParams.get('id'),
        notes: values?.notes,
        uom: values?.uom,
        retest_date: values?.retest_date,
        equipment_name: values?.equipment_name,
        identification_qty: values?.identification_qty,
        pooled_qty: values?.pooled_qty,
        material_type: values?.material_type || '',
        conversion_factor: showConversionFields
          ? values?.conversion_factor
          : '',
        source_uom: showConversionFields ? values?.source_uom : ''
      };
      setSampleData(payload);
      // dispatch(updateSampling(payload)).then((response) => {
      //   if (response?.payload?.success) {
      //     setTruckShow(false);
      //     message.success(response?.payload?.message);
      //     history.push('/samples-list');
      //   } else {
      //     setTruckShow(false);
      //   }
      // });
    }
  };

  const handleBalance = (e) => {
    let booth_details = dispenseBooths.filter((item) => item?.ip_address == e);
    setIpAddress(e);
    setPortID(booth_details?.[0]?.port);
    setBalanceType(booth_details?.[0]?.type);
  };

  /* Read the current weight from the selected sampling balance into the given
     form field (ID test sample / Pooled sample), then recompute Quantity. */
  const handleReadBalance = (fieldName) => {
    const payload = { ip: ipAddress, type: balancetype, port: portID };
    if (!payload?.ip) {
      message.error('Please select equipment name before you read weight');
      return;
    }
    dispatch(getBalance(payload)).then((response) => {
      if (response?.payload?.success) {
        const weight =
          Math.floor(parseFloat(response?.payload?.data) * 1000) / 1000;
        form.setFieldsValue({ [fieldName]: weight });
        calculateQuantity();
        message.success(response?.payload?.message);
      } else {
        message.error(response?.payload?.message || 'Failed to read weight');
      }
    });
  };

  // const handleQA = () => {
  //   setIsModal(true);
  // };

  const columns = [
    {
      title: 'Container Number',
      dataIndex: 'container_num',
      key: 'container_num',
      ellipsis: true,
      width: '100px'
      // render: (_, record) => {
      //   return record?.container?.number ? record?.container?.number : 'NA';
      // }
    },
    {
      title: 'AR Number',
      dataIndex: 'ar_number',
      key: 'ar_number',
      ellipsis: true,
      width: '100px'
    },
    {
      title: 'ID test sample',
      dataIndex: 'identification_qty',
      key: 'identification_qty',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.identification_qty != null
          ? parseFloat(record?.identification_qty)
          : 'NA';
      }
    },
    {
      title: 'Pooled sample',
      dataIndex: 'pooled_qty',
      key: 'pooled_qty',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.pooled_qty != null
          ? parseFloat(record?.pooled_qty)
          : 'NA';
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.quantity != null
          ? `${parseFloat(record?.quantity).toFixed(3)}${record?.uom || ''}`
          : 'NA';
      }
    },
    {
      title: 'Material Type',
      dataIndex: 'material_type',
      key: 'material_type',
      ellipsis: true,
      width: '100px',
      render: (text) => text || 'NA'
    },
    {
      title: 'CF',
      dataIndex: 'conversion_factor',
      key: 'conversion_factor',
      ellipsis: true,
      width: '80px',
      render: (text) => (text ? parseFloat(text) : 'NA')
    },
    {
      title: 'Source UOM',
      dataIndex: 'source_uom',
      key: 'source_uom',
      ellipsis: true,
      width: '100px',
      render: (text) => text || 'NA'
    },
    {
      title: 'Batch Number',
      dataIndex: 'batch_details_id',
      key: 'batch_details_id',
      ellipsis: true,
      width: '100px'
    },
    {
      title: 'Sampling Date',
      dataIndex: 'sampling_date',
      key: 'sampling_date',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return moment(text).format('DD-MM-YYYY');
      }
    },
    {
      title: 'Action',
      dataIndex: 'index',
      key: 'id',
      ellipsis: true,
      width: '100px',
      // render: (_, _, index) => {
      //   return <DeleteOutlined onClick={() => removeContainer(index)} />;
      // }
      render: (text, record, index) => {
        return <DeleteOutlined onClick={() => removeContainer(index)} />;
      }
    }
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Card
        title={<span>UPDATE SAMPLING WEIGHT DETAILS</span>}
        className={`${styles.cardStyles_approver}`}
        extra={
          user?.level == 3 ? (
            <CustomButton onClick={() => setIsEdit(false)}>
              <EditOutlined />
            </CustomButton>
          ) : (
            ''
          )
        }
      >
        <Row gutter={24}>
          <Col xs={2} xl={2} span={2} md={2} sm={2}>
            <CustomButton
              onClick={() => setOpenCam(true)}
              className={styles.qrcode}
            >
              <QrcodeOutlined onClick={() => setOpenCam(true)} />
            </CustomButton>
          </Col>
          <Col xs={10} xl={6} span={6} md={10} sm={10}>
            <FormItem
              name="warehouse_containers"
              label="Warehouse Containers"
              rules={[
                {
                  required: false,
                  message: 'Enter warehouse containers'
                }
              ]}
              className={styles.customLable}
            >
              <Select
                showSearch
                placeholder="Scan or select container"
                optionFilterProp="children"
                onChange={onChange}
                onSearch={onSearch}
                disabled={searchParams.get('id') ? true : false}
              >
                {containers?.map((item, index) => {
                  return containers ? (
                    <option value={item.number} key={index}>
                      {item.number}
                    </option>
                  ) : (
                    <Spin />
                  );
                })}
              </Select>
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="AR Number"
              // name="ar_number"
              rules={[
                {
                  required: false,
                  message: 'Enter AR Number'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                value={
                  searchParams.get('id') !== ''
                    ? containerDetails[0]?.batch_detail?.ar_number
                    : containerDetails[0]?.batch_detail?.ar_number || 'NA'
                }
                disabled
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Material Code"
              rules={[
                {
                  required: true,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                disabled
                value={
                  searchParams.get('id') !== ''
                    ? containerDetails[0]?.batch_detail?.material?.code
                    : containerDetails[0]?.batch_detail?.material?.code || 'NA'
                }
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Material Name"
              rules={[
                {
                  required: false,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                value={`${
                  searchParams.get('id')
                    ? containerDetails[0]?.batch_detail?.material?.name
                    : containerDetails[0]?.batch_detail?.material?.name || 'NA'
                }`}
                disabled
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Batch Number"
              rules={[
                {
                  required: false,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                value={
                  searchParams.get('id') !== ''
                    ? containerDetails[0]?.batch_detail?.inhouse_batch_number
                    : containerDetails[0]?.batch_detail?.inhouse_batch_number ||
                      'NA'
                }
                disabled
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Received Date"
              rules={[
                {
                  required: false,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                value={`${
                  containerDetails[0]?.received_date
                    ? moment(containerDetails[0]?.received_date).format(
                        'DD-MMM-YYYY'
                      )
                    : 'NA'
                }`}
                disabled
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12}>
            <FormItem
              label="Equipment Name"
              name="equipment_name"
              className={styles.customLable}
              rules={[
                {
                  required: true,
                  message: 'Please select the equipment name'
                }
              ]}
            >
              <Select
                placeholder="Select Balance Name"
                onChange={(e) => handleBalance(e)}
                disabled={searchParams.get('id') ? isEdit : false}
              >
                {dispenseBooths?.map((item, index) => {
                  return (
                    <option value={item?.ip_address} key={index}>
                      {item?.dispense_booth_id}
                    </option>
                  );
                })}
              </Select>
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Material Type"
              name="material_type"
              className={styles.customLable}
              rules={[
                {
                  required: true,
                  message: 'Please select material type'
                }
              ]}
            >
              <Select
                placeholder="Select Material Type"
                onChange={handleMaterialTypeChange}
                disabled={searchParams.get('id') ? isEdit : false}
              >
                <option value="Raw Material">Raw Material</option>
                <option value="Packing">Packing</option>
                <option value="Solvent">Liquid</option>
                <option value="Capsules">Capsules</option>
              </Select>
            </FormItem>
          </Col>
          {showConversionFields && (
            <Col xs={24} xl={8} span={12} md={24} sm={24}>
              <FormItem
                label="Conversion Factor"
                name="conversion_factor"
                className={styles.customLable}
                rules={[
                  {
                    required: true,
                    message: 'Enter conversion factor'
                  },
                  {
                    validator: (_, value) => {
                      if (value && (isNaN(value) || parseFloat(value) <= 0)) {
                        return Promise.reject(
                          'Conversion factor must be a number greater than 0'
                        );
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <InputNumber
                  placeholder="Enter Conversion Factor"
                  min={0}
                  step={0.001}
                  style={{ width: '100%' }}
                  onChange={calculateQuantity}
                  disabled={searchParams.get('id') ? isEdit : false}
                />
              </FormItem>
            </Col>
          )}
          {showConversionFields && (
            <Col xs={24} xl={8} span={12} md={24} sm={24}>
              <FormItem
                label="Source UOM"
                name="source_uom"
                className={styles.customLable}
                rules={[
                  {
                    required: true,
                    message: 'Please select source UOM'
                  }
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select Source UOM"
                  optionFilterProp="children"
                  disabled={searchParams.get('id') ? isEdit : false}
                >
                  <option value="Grams">Grams</option>
                  <option value="ml">Milliliters(ML)</option>
                  <option value="No.'s">{`No.'s`}</option>
                </Select>
              </FormItem>
            </Col>
          )}
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="ID test sample"
              required
              className={styles.customLable}
            >
              <div
                style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'flex-start'
                }}
              >
                <div style={{ flex: 1 }}>
                  <FormItem
                    name="identification_qty"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: 'Enter Identification test sample'
                      }
                    ]}
                  >
                    <InputNumber
                      placeholder="Enter Identification test sample"
                      min={0}
                      step={0.001}
                      style={{ width: '100%' }}
                      onChange={calculateQuantity}
                      disabled={searchParams.get('id') ? isEdit : false}
                    />
                  </FormItem>
                </div>
                <CustomButton
                  style={{ color: '#c91761' }}
                  onClick={() => handleReadBalance('identification_qty')}
                  disabled={searchParams.get('id') ? isEdit : false}
                >
                  Read
                </CustomButton>
              </div>
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Pooled sample"
              required
              className={styles.customLable}
            >
              <div
                style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'flex-start'
                }}
              >
                <div style={{ flex: 1 }}>
                  <FormItem
                    name="pooled_qty"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: 'Enter pooled sample'
                      }
                    ]}
                  >
                    <InputNumber
                      placeholder="Enter pooled sample"
                      min={0}
                      step={0.001}
                      style={{ width: '100%' }}
                      onChange={calculateQuantity}
                      disabled={searchParams.get('id') ? isEdit : false}
                    />
                  </FormItem>
                </div>
                <CustomButton
                  style={{ color: '#c91761' }}
                  onClick={() => handleReadBalance('pooled_qty')}
                  disabled={searchParams.get('id') ? isEdit : false}
                >
                  Read
                </CustomButton>
              </div>
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Quantity"
              name="quantity"
              rules={[
                {
                  required: true,
                  message: 'Enter Quantity'
                }
              ]}
              className={styles.customLable}
            >
              <InputNumber
                placeholder="Enter Quantity"
                style={{ width: '100%' }}
                disabled
              />
            </FormItem>
            {showConversionFields &&
              form.getFieldValue('identification_qty') &&
              form.getFieldValue('conversion_factor') && (
                <div
                  style={{
                    marginTop: '-12px',
                    marginBottom: '4px',
                    fontSize: '12px',
                    color: '#888'
                  }}
                >
                  {materialType === 'Capsules'
                    ? 'quantity = (identification_qty + pooled_qty) × (1000 / conversion_factor)'
                    : 'quantity = (identification_qty + pooled_qty) × conversion_factor'}
                  {/* ({form.getFieldValue('identification_qty') || 0} +{' '}
                  {form.getFieldValue('pooled_qty') || 0}) ×{' '}
                  {form.getFieldValue('conversion_factor') || 1} ={' '}
                  {form.getFieldValue('quantity')} */}
                </div>
              )}
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="UOM"
              rules={[
                {
                  required: true,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
              name="uom"
            >
              <Select
                showSearch
                placeholder="Select UOM"
                optionFilterProp="children"
                disabled={searchParams.get('id') ? true : false}
              >
                <option value="Grams">Grams</option>
                <option value="ml">Milliliters(ML)</option>
                <option value="No.'s">{`No.'s`}</option>
              </Select>
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Sampling Date"
              name="sampling_date"
              rules={[
                {
                  required: false,
                  message: 'Select Sampling Date'
                }
              ]}
              className={styles.customLable}
            >
              <DatePicker
                defaultValue={moment()}
                format={dateFormat}
                style={{ width: '100%' }}
                disabled
              />
            </FormItem>
          </Col>
          {searchParams.get('id') ? (
            <Col xs={24} xl={24} span={24} md={24} sm={24}>
              <FormItem
                label="Comments"
                name="notes"
                rules={[
                  {
                    required: false,
                    message: 'Enter Ntes'
                  }
                ]}
                className={styles.customLable}
              >
                <TextArea
                  value={
                    searchParams.get('id')
                      ? containerDetails[0]?.batch_detail?.notes
                      : ''
                  }
                  rows={4}
                  disabled={searchParams.get('id') ? isEdit : false}
                />
              </FormItem>
            </Col>
          ) : (
            ''
          )}
        </Row>
        <br />
        <FormItem className="text-center">
          {searchParams.get('id') && !isEdit ? (
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              // onClick={() => handleQA()}
              type="primary"
            >
              Initiate Verification
            </CustomButton>
          ) : (
            ''
          )}
          {!searchParams.get('id') ? (
            truckShow ? (
              <Image
                src={truck}
                preview={false}
                style={{ width: '100px !important', height: '100px' }}
              />
            ) : (
              <CustomButton
                className={styles.inwardButton}
                // htmlType="submit"
                onClick={handleAddContainer}
                type="primary"
                disabled={!lCStatus}
              >
                Next
              </CustomButton>
            )
          ) : (
            ''
          )}
        </FormItem>
      </Card>
      <QrScanSingleShotModal
        title="Scan Container QR"
        visible={openCam}
        onCancel={() => setOpenCam(false)}
        hint="Point the camera at a container QR code."
        onScan={(decodedText) => handleQrScan({ text: decodedText })}
      />
      <Card
        title={<span>Sampling Details</span>}
        className={`${styles.cardStyles_approver}`}
      >
        {!searchParams.get('id') && sampledContainers?.length > 0 ? (
          <div style={{ marginBottom: '12px' }}>
            <span style={{ marginRight: '8px', fontWeight: 500 }}>
              Already sampled in this batch:
            </span>
            {sampledContainers.map((c, index) => (
              <Tag color="orange" key={`${c?.number}-${index}`}>
                {c?.number}
              </Tag>
            ))}
          </div>
        ) : (
          ''
        )}
        <div className={`${styles.table_container}`}>
          <CustomTable
            columns={columns}
            pagination={false}
            scroll={{ x: 'auto' }}
            // dataSource={pastData}
            dataSource={samplingData}
            rowKey="id"
          />
        </div>
      </Card>
      <br />
      <FormItem className="text-center">
        <Space>
          {' '}
          <CustomButton
            className={styles.inwardButton}
            onClick={() => history.back()}
            type="primary"
          >
            Back to Home
          </CustomButton>
          {isSubmit ? (
            <Spin size="large" />
          ) : (
            <CustomButton
              className={styles.inwardButton}
              // htmlType="submit"
              type="primary"
              onClick={onSubmit}
            >
              Submit
            </CustomButton>
          )}
        </Space>
      </FormItem>
      {isModal ? (
        <VerificationModal
          isModal={isModal}
          materials={sampleData}
          setIsModal={setIsModal}
          setIsEdit={setIsEdit}
          page="sampling"
        />
      ) : (
        ''
      )}
    </Form>
  );
};
export default SamplingMaterialsPage;
